'use client'

import cn from 'clsx'
import { useRect, useWindowSize } from 'hamo'
import { useLenis } from 'lenis/react'
import { useRef, useState } from 'react'
import { useDeviceDetection } from '~/hooks/use-device-detection'
import { mobileVW } from '~/libs/utils'
import { DepthImage } from '../depth-image'

const tempImages = [
  {
    src: '/images/IMG_4129.jpeg',
    depthSrc: '/images/IMG_4129-depth.png',
  },
  {
    src: '/images/IMG_4129.jpeg',
    depthSrc: '/images/IMG_4129-depth.png',
  },
  {
    src: '/images/IMG_4129.jpeg',
    depthSrc: '/images/IMG_4129-depth.png',
  },
]

export function ImageScroller({ images = tempImages }) {
  const lenis = useLenis()
  const [selectedImage, setSelectedImage] = useState(0)
  const [isScrolling, setIsScrolling] = useState(false)
  const { isDesktop } = useDeviceDetection()
  const { width } = useWindowSize()
  const [rectRef, rect] = useRect()
  const scrollerRef = useRef(null)

  function handleImageNav(idx) {
    if (isDesktop) {
      setSelectedImage(idx)
      lenis.scrollTo(`#image-${idx}`, {
        onStart: () => setIsScrolling(true),
        onComplete: () => setIsScrolling(false),
      })
    } else {
      scrollerRef.current.scrollTo({
        left: idx * rect.width + mobileVW(8, width) * idx,
        behavior: 'smooth',
      })
    }
  }

  return (
    <section className="col-span-full dt:col-span-4 dt:spb-120 ">
      <div
        ref={scrollerRef}
        className="relative w-full"
        onScroll={(e) => {
          if (!isScrolling) {
            setSelectedImage(
              Math.floor(e.target.scrollLeft / (rect.width * 0.9))
            )
          }
        }}
      >
        <ul className="flex w-max dt:w-full dt:flex-col sgap-8 dt:sgap-16">
          {images?.map((image, idx) => (
            <li
              key={image.url}
              className={cn(
                'relative w-[calc(100vw-2*var(--safe))] dt:w-full',
                !image.depthUrl && 'scan-lines'
              )}
              id={`image-${idx}`}
              ref={rectRef}
            >
              <DepthImage
                className="w-full grid place-items-center"
                fill={!!image?.depthUrl}
                src={image?.url}
                depthSrc={image?.depthUrl}
                mobileSize="100vw"
                desktopSize="50vw"
                width={!image?.depthUrl ? image?.width : undefined}
                height={!image?.depthUrl ? image?.height : undefined}
                priority
                onInView={() => {
                  if (!isScrolling) {
                    setSelectedImage(idx)
                  }
                }}
              />
            </li>
          ))}
        </ul>
        <nav className="mt-gap dt:mt-0 dt:sticky dt:sbottom-64 dt:spl-32 z-10 flex justify-between dt:justify-start sgap-8 py-gap">
          {images?.map((image, idx) => (
            <button
              key={image?.url}
              type="button"
              className={cn(
                'cta desktop-only',
                idx !== selectedImage && 'opacity-50'
              )}
              onClick={() => handleImageNav(idx)}
            >
              {idx + 1}.
            </button>
          ))}
          <div className="mobile-only flex sgap-8 cta">
            <p>{selectedImage + 1}.</p>
            <p className="opacity-50">/</p>
            <p className="opacity-50">{images?.length}.</p>
          </div>
          <div className="mobile-only flex sgap-16 -translate-y-1/6">
            <button
              type="button"
              onClick={() => handleImageNav(Math.max(selectedImage - 1, 0))}
            >
              ←
            </button>
            <button
              type="button"
              onClick={() =>
                handleImageNav(Math.min(selectedImage + 1, images?.length - 1))
              }
            >
              →
            </button>
          </div>
        </nav>
      </div>
    </section>
  )
}
